var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Paper, List } from '@mui/material';
import { Upload as UploadIcon } from '@mui/icons-material';
import UploadItem from './UploadItem';
import { DropArea } from './Uploader.styles';
var getFileId = function (file) {
    return "".concat(file.path, "_").concat(file.lastModified, "_").concat(file.size);
};
var Upload = function (props) {
    var onUploadReady = props.onUploadReady, fileList = props.fileList;
    var onRemoveFile = function (id) {
        var newFileList = {};
        if (Object.keys(fileList).length > 0) {
            Object.values(fileList).forEach(function (fileListItem) {
                if (fileListItem && fileListItem.id !== id) {
                    newFileList[fileListItem.id] = fileListItem;
                }
            });
        }
        onUploadReady(newFileList);
    };
    var onDrop = function (acceptedFiles) {
        var newFileList = __assign({}, fileList);
        acceptedFiles.forEach(function (file) {
            var fileReader = new FileReader();
            fileReader.onload = function () {
                var contents = fileReader.result;
                var id = getFileId(file);
                newFileList[id] = {
                    file: file,
                    contents: contents,
                    id: id,
                };
                onUploadReady(newFileList);
            };
            fileReader.readAsArrayBuffer(file);
        });
    };
    var dropzoneConfig = { onDrop: onDrop };
    if (props.accept) {
        dropzoneConfig.accept = props.accept;
    }
    if (props.maxFiles) {
        dropzoneConfig.maxFiles = props.maxFiles;
    }
    var _a = useDropzone(__assign({}, dropzoneConfig)), getRootProps = _a.getRootProps, getInputProps = _a.getInputProps, isDragActive = _a.isDragActive;
    var renderFileList = function () {
        var files = fileList ? Object.values(fileList) : [];
        if (files.length > 0) {
            return (React.createElement(List, null, files.map(function (fileListItem) {
                if (fileListItem) {
                    return (React.createElement(UploadItem, { key: fileListItem.id, file: fileListItem, onRemoveItem: onRemoveFile }));
                }
                return null;
            })));
        }
        return null;
    };
    return (React.createElement(Box, null,
        React.createElement(Paper, null,
            React.createElement(DropArea, __assign({}, getRootProps(), { active: isDragActive }),
                React.createElement("input", __assign({}, getInputProps())),
                React.createElement("p", null,
                    React.createElement(UploadIcon, null)),
                isDragActive ? (React.createElement("p", null, "Drop the files here")) : (React.createElement("p", null, props.label ||
                    "Drag 'n' drop some files here, or click to select files"))),
            React.createElement("div", null, renderFileList()))));
};
export default Upload;
